import { IProductKlaviyo } from '@monofront/types';

type KlaviyoEvents =
  | {
      name: 'Checkout Started';
      data: {
        $event_id: string;
        $value: number;
        eventSource: 'app' | 'web';
        extra: {
          line_items: Array<{
            product: {
              handle: string;
              title: string;
              variant: {
                images: Array<{
                  src: string | undefined;
                }>;
              };
            };
            quantity: number;
            line_price: number;
          }>;
        };
        Items: Array<string>;
      };
    }
  | {
      name: 'Viewed Product';
      data: IProductKlaviyo & {
        eventSource: 'app' | 'web';
      };
    }
  | {
      name: 'Membership profitable';
      data: {
        SubscriptionAmount: string;
        SavingsAmount: string;
        DaysSinceFreeTrialStarted: number | null;
      };
    };

const getKlaviyo = () => {
  if (typeof window != 'undefined') {
    if (window.klaviyo) return window.klaviyo;

    window.lfMockKlaviyo = window.lfMockKlaviyo || [];

    return window.lfMockKlaviyo;
  }

  return undefined;
};

export const klaviyoIdentify = (data: Record<string, any>) => {
  getKlaviyo()?.push(['identify', data]);
};

export const klaviyoTrackEvent = ({ name, data }: KlaviyoEvents) => {
  getKlaviyo()?.push(['track', name, data]);
};

export const klaviyoTrackViewedItem = (data: {
  Title: string;
  ItemId: string | number;
  Categories: Array<string>;
  ImageUrl: string | undefined;
  Url: string;
  Metadata: {
    Brand: string;
    Price: number;
    CompareAtPrice: number;
  };
}) => {
  getKlaviyo()?.push(['trackViewedItem', data]);
};
